
import { AuthMixin } from '@/mixins/AuthMixin';
import { WeddingEventImageCommentSettings } from '@/types/wedding';
import { mixins } from 'vue-class-component';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  name: 'wedding-event-image-comment-form',
})
export default class WeddingEventImageCommentForm extends mixins(AuthMixin) {
  @Prop({ required: true, type: Object, default: () => ({ name: '', comment: '' }) })
  readonly value!: WeddingEventImageCommentSettings;

  @Prop({ required: false, type: Boolean, default: false })
  readonly isPublic!: boolean;

  get commentData(): WeddingEventImageCommentSettings {
    return this.value;
  }

  get isValid(): boolean {
    return !!this.commentData.name && !!this.commentData.comment;
  }

  onInput(key: keyof WeddingEventImageCommentSettings, value: string) {
    const updatedValue = { ...this.commentData };
    updatedValue[key] = value;
    this.$emit('input', updatedValue);
  }

  @Emit('submit')
  submitComment() {
    return this.commentData;
  }
}
